import { OrderPaymentType } from "@sellar-io/api-v2/types";
import { FormEvent, ReactElement } from "react";
import {
  InputField,
  RadioSelector,
  RadioSelectorItem,
} from "@sellar-io/components";
import { useRemoteFeatureFlags } from "~/hooks/useRemoteFeatureFlags";

export function OrderPaymentMethodFormFragment({
  onChange,
  isProforma,
  paymentType,
  stripeAccountId,
  buyerName,
  retailerPreference,
  disabled,
}: {
  paymentType?: OrderPaymentType | null;
  retailerPreference?: OrderPaymentType | null;
  stripeAccountId?: string | null;
  buyerName: string;
  onChange: (e: FormEvent<HTMLInputElement>) => void;
  isProforma?: boolean;
  disabled?: boolean;
}): ReactElement {
  const { isActive } = useRemoteFeatureFlags();
  const isPaymentLinkRequestActive = isActive("checkoutPaymentLinkRequest");

  return (
    <>
      <InputField label={"Payment method"} containerClassName="border-none p-0">
        <>
          {stripeAccountId && !isPaymentLinkRequestActive ? (
            <RadioSelector
              onChange={onChange}
              value={paymentType ?? ""}
              required={true}
              variant="grouped"
            >
              <RadioSelectorItem
                disabled={disabled}
                value={"stripe"}
                title={`Card payment${
                  retailerPreference === "stripe"
                    ? ` (${buyerName}'s preference)`
                    : ""
                }`}
                description={
                  isProforma
                    ? `This will create and finalise the invoice on Stripe and ${buyerName} will receive a link to make a payment via credit or debit card.`
                    : `You'll be able to issue the invoice after confirming the order.`
                }
              />
              <RadioSelectorItem
                disabled={disabled}
                value={"manual"}
                title={`Invoice manually${
                  retailerPreference === "manual"
                    ? ` (${buyerName}'s preference)`
                    : ""
                }`}
                description={`Arrange payment outside of Sellar.${
                  isProforma
                    ? ` ${buyerName} will be able to access their VAT invoice from the Sellar app.`
                    : ""
                }`}
              />
            </RadioSelector>
          ) : (
            <RadioSelector value={"manual"} variant="grouped">
              <RadioSelectorItem
                disabled={disabled}
                value={"manual"}
                title={
                  isPaymentLinkRequestActive
                    ? "Direct payment from customer"
                    : "Invoice manually"
                }
                description={
                  isPaymentLinkRequestActive
                    ? "Customer can pay using a card payment link or arrange to pay you outside of Sellar."
                    : `Arrange payment outside of Sellar.${
                        isProforma
                          ? ` ${buyerName} will be able to access their VAT invoice from the Sellar app.`
                          : ""
                      }`
                }
              />
            </RadioSelector>
          )}
        </>
      </InputField>
    </>
  );
}
